import { render, staticRenderFns } from "./WorkflowWrapper.vue?vue&type=template&id=63340969&"
import script from "./WorkflowWrapper.vue?vue&type=script&lang=js&"
export * from "./WorkflowWrapper.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports